import React from 'react';
import {
    ArrowIcon,
    ImgContainer,
    LinkWrapper,
    PageName,
    PageNameContainer,
    PageSubText,
} from '../../styles/dropdown.style';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import Icon_right from '../../../../images/Icons/at_chevron-right.svg';

const PageLink = ({ item }) => {
    const currentPath = window.location.pathname;
    const isSmallScreen = useMediaQuery('(max-width: 760px)');
    return (
        <LinkWrapper>
            <PageNameContainer>
                <PageName active={currentPath === item.link}>{item.label}</PageName>
                <ArrowIcon src={Icon_right} alt="icon-right" active={currentPath === item.link} />
            </PageNameContainer>
            <PageSubText>{item.subText}</PageSubText>
            {!isSmallScreen && item.img && (
                <ImgContainer>
                    <img src={item.img} alt={`${item.label}-img`} />
                </ImgContainer>
            )}
        </LinkWrapper>
    );
};

PageLink.propTypes = {
    item: PropTypes.object,
};

export default PageLink;
